import {Box, Button} from '@mui/material';
import {useEffect, useState} from 'react';
import {handleTracking, openUrl} from '@jobseeker/common-core/utils';
import {AppState} from '@jobseeker/common-core/types';
import {shallowEqual, useSelector} from 'react-redux';
import {getDownloadAppBannerData} from '@jobseeker/feature-ads/utils/bannerInfo';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';

interface ButtonType {
  redirectLink: string;
  label: string;
}

const FloatingDownloadButton = () => {
  const [downloadBannerData, setDownloadBannerData] =
    useState<ButtonType | null>(null);
  const page = useSelector((state: AppState) => state.app.page, shallowEqual);
  const startTime = new Date().getDate() % 3;
  const bannerId = startTime + 1;
  const interceptor: any = useInterceptor();
  const {
    ads: {hiristDownloadBanner},
    gaEvents: {downloadApp: banner},
  } = interceptor;

  const slots = {
    TOP: hiristDownloadBanner?.[0]?.slot,
    MIDDLE: hiristDownloadBanner?.[1]?.slot,
    BOTTOM: hiristDownloadBanner?.[2]?.slot,
  };

  useEffect(() => {
    const fetchBannerData = async () => {
      const data = await getDownloadAppBannerData(page, slots, banner);
      setDownloadBannerData(data);
    };
    fetchBannerData();
  }, []);

  const redirectToApp = (redirectLink: string) => {
    handleTracking(banner['click'], {
      event_category: banner['eventCategory'],
      Origin: page,
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
      Text: `Banner ${bannerId}`,
    });
    openUrl(redirectLink);
  };
  return (
    downloadBannerData && (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          position: 'fixed',
          bottom: '27px',
          width: '92%',
          zIndex: 12,
          height: '42px',
        }}
      >
        <Button
          sx={{
            fontSize: '12px',
            fontWeight: '800',
            px: '17px',
            py: '13px',
            lineHeight: '1.4',
            height: '42px',
            backgroundColor: '#fff3ef',
            borderRadius: '21px',
            border: '1px solid primary.main',
            color: 'primary.main',
            '&:hover': {
              backgroundColor: '#fff3ef',
            },
          }}
          variant="outlined"
          size="small"
          onClick={() => {
            redirectToApp(downloadBannerData['redirectLink']);
          }}
        >
          {downloadBannerData['label']}
        </Button>
      </Box>
    )
  );
};

export default FloatingDownloadButton;
